<template>
    <div>
        <div class="banner"></div>
        <div class="content">
            <div class="contentCom">
                <el-row>
                    <el-col :span="5">
                        <div class="title">
                            联系我们 <br/>
                            <span style="font-size:16px;">
                                Policies and Regulations
                            </span>
                        </div>
                        <div class="menu">
                            <div class="qygkContent">
                                <div v-for="(item,index) in menuList" :key="item.url" @click="tab(item)" class="name" :class="{'active':item.active}">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="18" :offset="1">
                        <div class="nrTitle">
                            {{titleName}}
                        </div>
                        <div class="lyContent" v-if="page === '62'">
                            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                                <el-form-item label="姓名" prop="name">
                                    <el-input v-model="form.name"></el-input>
                                </el-form-item>
                                <el-form-item label="联系方式" prop="phone">
                                    <el-input v-model="form.phone"></el-input>
                                </el-form-item>
                                <el-form-item label="内容" prop="content">
                                    <el-input type="textarea" v-model="form.content"></el-input>
                                </el-form-item>
                                <el-form-item label="验证码" prop="code">
                                    <div class="code">
                                        <el-input v-model="form.code"></el-input>
                                        <div class="picCode" @click="changeCode()">
                                            <identify :identifyCode="identifyCode"></identify>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="onSubmit">提交</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="nrContent" v-if="page === '63'">
                            <div class="mapContent">
                                <baidu-map style="height: 400px;" :center="map.center" :zoom="map.zoom"
                                    :scroll-wheel-zoom="true"
                                    class="baidu-map-view"
                                    @ready="map_handler" ak="SjucjOPirN8luhvcp2PtU57LVMGKKyTG">
                                    <bm-marker :position="{lng: 119.192663, lat: 34.602293}">
                                        <bm-label  content="连云港格润环保科技有限公司" :offset="{width: -85, height: 50}" :labelStyle="{ fontSize : '16px'}"/>
                                    </bm-marker>
                                </baidu-map>
                            </div>
                            <div class="xxContent">
                                <div class="logo">
                                    <img width="100%" src="../assets/images/logo.png" alt="">
                                </div>
                                <div class="location">
                                    <div>
                                        <span class="spanImg"><i class="el-icon-location-outline"></i></span>
                                    </div>
                                    <div>
                                        <div>地址1：连云港市灌云经济开发区纬三路30号（灌云）</div>
                                        <div>地址2：连云港市海州区朝阳东路32-6东盛阳光大厦B座408</div>
                                    </div>
                                </div>
                                <div class="location">
                                    <div>
                                        <span class="spanImg"><i class="el-icon-phone-outline"></i></span>
                                    </div>
                                    <div>
                                        <div>董经理：19901559100</div>
                                        <div>张总：18795550660</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="talentSyle" v-if="page === '61'">
                            <div v-for="(item, index) in content" :key="index">
                                <div class="rcTitle">
                                    <div>{{ item.noticeTitle }}</div>
                                    <div>{{ item.createTime }}</div>
                                </div>
                                <div v-html="item.noticeContent"></div>
                            </div>
                            <!-- <div class="page">
                                <el-pagination
                                    layout="prev, pager, next"
                                    :total="total"
                                    :page-size="3"
                                    @current-change="changePage"
                                    >
                                </el-pagination>
                            </div> -->
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import identify from '@/components/identify.vue';
import { BaiduMap, BmMarker, BmLabel } from 'vue-baidu-map'
export default {
    components: {
        BaiduMap,
        BmMarker,
        BmLabel,
        identify
    },
    data() {
        return {
            // 验证码初始值
            identifyCode: 'm6a8',
            // 验证码的随机取值范围
            identifyCodes: '123456789abcdefghjkmnpqrstuvwxyz',
		
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ],
            },
            form: {
                name: '',
                phone: '',
                content: '',
                code:''
            },
            map:{
                center: {lng: 119.192663, lat: 34.602293},
                zoom: 15,
            },
            page:'61',
            titleName:'人才招聘',
            menuList:[
                {
                    name:'人才招聘',
                    url:'61',
                    active:true,
                },{
                    name:'客户留言',
                    url:'62',
                    active:false,
                },{
                    name:'联系我们',
                    active:false,
                    url:'63'
                }
            ],
            listData: [
            ],
            content:[],
            total:0
        }
    },

    mounted() {
        // 刷新页面就生成随机验证码
        this.identifyCode = ''
        this.makeCode(this.identifyCodes, 4)
        this.getData(1, 10)
        if (this.$route.query) {
            if (this.$route.query.page) {
                this.page = this.$route.query.page
            }
            this.menuList.forEach(val => {
                val.active = false
                if (val.url == this.page) {
                    val.active = true
                    this.titleName = val.name
                }
            });
        }
    },
    methods: {
        // 点击验证码刷新验证码
        changeCode() {
            this.identifyCode = ''
            this.makeCode(this.identifyCodes, 4)
        },
        // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
        randomNum(min, max) {
            max = max + 1
            return Math.floor(Math.random() * (max - min) + min)
        },
        // 随机生成验证码字符串
        makeCode(data, len) {
            for (let i = 0; i < len; i++) {
                this.identifyCode += data[this.randomNum(0, data.length - 1)]
            }
        },
        async getData(num,size){
            var data = {
                noticeType: '1',
                pageSize:size,
                pageNum:num,
            }
            const {data:res} = await this.$autPost(data,this.$getDataUrl)
            res.rows.forEach(val => {
                val.createTime = moment(val.createTime).format('YYYY-MM-DD')
            });
            this.content = res.rows
            this.total = res.total
        },
        changePage(num) {
            this.getData(num, 3)
        },
        onSubmit(){
             this.$refs['form'].validate(async(valid) => {
                if (valid) {
                    if (this.identifyCode != this.form.code ) {
                        this.$message({
                            message: '验证码不正确',
                            type: 'warning'
                        });
                        this.changeCode();// 改变验证码
                        return
                    } 
                    const {data:res} = await this.$autPost(this.form,this.$getAddUrl)
                    if (res.code === 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        // this.$refs['form'].resetFields();
                    } else {
                        this.changeCode()
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 地图初始化回调
        map_handler({ BMap, map }) {
            this.map.center = {lng: 119.192663, lat: 34.602293}
            this.map.zoom = 15
        },
        tab(item){
            this.menuList.forEach(val => {
                val.active = false
            });
            this.titleName = item.name
            item.active = true
            this.page = item.url
            this.$router.push({
                path:'/contact',
                query:{
                    page:item.url,
                },
            })
        },
    },
}
</script>

<style scoped>
    .code {
        display: flex;
        align-items: center;
    }
    .picCode {
        border: 1px solid #DCDFE6;
        cursor: pointer;
    }
    .logo {
        padding: 10px 20px;
    }
    .banner {
        width: 1400px;
        margin: 0 auto;
        background: url(../assets/images/banner.jpg);
        height: 306px;
    }
    @media screen and (max-width: 1366px){
        .banner {
            width: 100%;
        }
    }
    .content {
        margin-top: 20px;
    }
    .contentCom {
        margin: 20px auto 50px;
        width: 1200px;
    }
    .title{
        background: #49A8F8;
        color: white;
        font-size: 20px;
        width: 100%;
        text-align: center;
        padding: 30px 0 20px;
    }
    .menu{
        width: 100%;
        text-align: center;
        font-size: 16px;
    }
    .qygkContent{
        background: #49A8F8;
        width: 100%;
        border-top: 1px dashed white;
        padding-bottom: 20px;
    }
    .name{
        width: 80%;
        margin: 0 auto;
        color: white;
        padding: 15px 0;
        border-bottom: 1px dashed white;
        cursor: pointer;
    }
    .name.active{
        color: #49A8F8;
        width: 100%;
        background: #eff7ff;
    }
    .nrTitle{
        width: 100%;
        font-size: 20px;
        color: #323232;
        padding:10px 0;
        border-bottom: 1px solid #aeaeae;
        font-weight: bold;
    }
    .mainContent {
        width: 100%;
    }
    .list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px dashed #DCDFE6;
        padding: 10px 0;
        color: #606266;
        cursor: pointer;
    }
    .word {
        width: 80%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 10%;
        color: #909399;
        font-size: 14px;
    }
    .page {
        text-align: center;
        padding-top: 20px;
    }
    .nrContent {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .mapContent {
        width: 70%;
    }
    .xxContent {
        width: 28%;
    }
    .location {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }
    .spanImg {
        font-size: 30px;
        margin-right: 10px;
        color: #77CBF0;
    }
    .lyContent {
        width: 60%;
        margin: 20px auto;
    }
    .rcTitle {
        background: #d3f1fd;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
    }
</style>